import { render } from "./RaceViews.vue?vue&type=template&id=60814ac4&scoped=true"
import script from "./RaceViews.vue?vue&type=script&lang=js"
export * from "./RaceViews.vue?vue&type=script&lang=js"

import "./RaceViews.vue?vue&type=style&index=0&id=60814ac4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60814ac4"]])

export default __exports__